import "./datepicker.scss";
import { Form } from "react-bootstrap";
import { useFormikContext, useField } from "formik";

const DatePicker = ({ name, title, required, onBlur, errorFromBackend }) => {
  const { handleChange, setFieldTouched, handleBlur } = useFormikContext(name);
  const [field, meta] = useField({
    name
  });

  return (
    <Form.Group>
      <Form.Label className="mb-1">{`${title}${required ? "*" : ""
        }`}</Form.Label>

      <Form.Control
        className="information-placeholder birthday-date"
        type="date"
        max="2999-12-31"
        name={name}
        onChange={handleChange}
        onFocus={() => setFieldTouched(name)}
        onBlur={async (e) => {
          handleBlur(e);
          onBlur && onBlur(e);
        }}
        value={field.value || ""}
        isInvalid={meta.touched && meta.error}
      />
      {meta.touched && meta.error ? (
        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
      ) : errorFromBackend ? (
        <div className="form-error mb-2">{errorFromBackend}</div>
      ) : null}
    </Form.Group>
  );
};

export default DatePicker;
